export default "__VITE_ASSET__CKjJsaNa__"